import { useMemo } from 'react';
import { Breakpoints } from '@picsart/design-system/foundation/responsive';
import { BREAKPOINTS } from '@/consts/breakpoints';
import useWindowWidth from '@/hooks/useWindowWidth';

// Column count is driven by window width.
// LG ≥1280: 4 / SM ≥768: 3 / narrow ≥280: 2 / else: 1
const getColumnCount = ({ width }: { width: number }): number => {
  if (width >= Breakpoints.lg) return 4;
  if (width >= Breakpoints.sm) return 3;
  if (width >= BREAKPOINTS.narrow) return 2;
  return 1;
};

const useGridColumns = () => {
  const windowWidth = useWindowWidth();
  const columnCount = useMemo(
    () => getColumnCount({ width: windowWidth }),
    [windowWidth]
  );
  return { columnCount };
};

export default useGridColumns;
